import React from 'react';
import { Modal, Button, Typography } from '@mui/material';

const NotificationModal = ({ open, onClose, title, content }) => {

  

  return (
    <Modal open={open} onClose={onClose}>
      <div style={{ padding: '20px', background: 'white', margin: '20% auto', width: '300px', borderRadius: '8px' }}>
        <Typography variant='H6' color='success' >{title}</Typography>
        <Typography variant="body" gutterBottom>
          {content}
        </Typography>
        <Button onClick={onClose} variant="outlined" color="primary" style={{ marginRight: '10px' }}>
          Ok
        </Button>
      </div>
    </Modal>
  );
};

export default NotificationModal;
